/**
 * Returns the result of calling `Array.join(', ')` on a list of entity names of a specific
 * roleType. For example, a list of all publisher names for a trqkSong. If the list is empty,
 * returns null instead.
 * @param trqkSong
 * @param targetRoleType
 */
export const getEntityListLabel = (
    trqkSong: TrqkSong,
    targetRoleType: ProRoleType,
): Maybe<string> => {
    const percentShares = trqkSong?.percent_shares ?? null;

    if (percentShares !== null) {
        const filteredEntities = percentShares.filter(
            ({ entity_role_type }: ProEntityPercentShare): boolean =>
                entity_role_type === targetRoleType,
        );

        if (filteredEntities !== undefined) {
            const entityList = filteredEntities.reduce(
                (
                    acc: string[],
                    { entity_name }: ProEntityPercentShare,
                ): string[] => {
                    if (entity_name !== null) {
                        acc.push(entity_name);
                    }

                    return acc;
                },
                [] as string[],
            );

            if (entityList.length === 0) {
                return null;
            }

            return entityList.join(', ');
        }
    }

    return null;
};
